import { useCallback, useContext } from 'react';
import {
  selectFullScreenDashboardMap,
  selectFullScreenMap,
  toggleDashboardFullScreen,
  toggleFullScreen,
} from '../../../../slices/ui';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { MapContext } from '../map';
import Context from './Context';

function Provider({ fitMap, children, toggleMarkerClusters }) {
  const { map } = useContext(MapContext);
  const dispatch = useAppDispatch();
  const isFullScreen = useAppSelector(selectFullScreenMap);
  const isDashboardFullScreen = useAppSelector(selectFullScreenDashboardMap);

  const toggleFullScreenCb = useCallback(() => {
    dispatch(toggleFullScreen());
    setTimeout(() => map.invalidateSize(), 50);
  }, [dispatch, map]);

  const toggleFullScreenDashboardCb = useCallback(() => {
    dispatch(toggleDashboardFullScreen());
    setTimeout(() => map.invalidateSize(), 50);
  }, [dispatch, map]);

  return (
    <Context.Provider
      value={{
        fitMap,
        toggleMarkerClusters,
        isFullScreen,
        isDashboardFullScreen,
        toggleFullScreen: toggleFullScreenCb,
        toggleFullScreenDashboard: toggleFullScreenDashboardCb,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export default Provider;
